import React from 'react';
import { Availability } from '../../../interfaces/Availability';

export interface ApplicationAvailabilityContextProps {
  availability?: Availability;
  saveAvailability(a: Availability): void;
}

const ApplicationAvailabilityContext = React.createContext<ApplicationAvailabilityContextProps>(null);

export default ApplicationAvailabilityContext;
